module.exports = __webpack_public_path__ + "static/img/seckill-price-wrap.c5f21043.png";